import { Moment } from 'moment';

export const passesDateRangeValidation = (
  startDate: Moment,
  endDate: Moment
): boolean => {
  if (endDate.startOf('day').isBefore(startDate.startOf('day'))) {
    return false;
  } else {
    return true;
  }
};

export const passesTimeRangeValidation = (
  startTime: Moment,
  endTime: Moment,
  startDate: Moment,
  endDate: Moment
): boolean => {
  const startDateTime = startDate.set({
    hour: startTime.hour(),
    minute: startTime.minute(),
    second: startTime.second(),
    millisecond: startTime.millisecond(),
  });

  const endDateTime = endDate.set({
    hour: endTime.hour(),
    minute: endTime.minute(),
    second: endTime.second(),
    millisecond: endTime.millisecond(),
  });

  if (endDateTime.isBefore(startDateTime)) {
    return false;
  } else {
    return true;
  }
};
